module.exports = __webpack_public_path__ + "img/ps-range.301bb90f.png";